var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDirections10 = function SvgIconDirections10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.222 5.301a7.25 7.25 0 0 1 7.902 1.575h.001l1.474 1.47h-2.08a1 1 0 1 0 0 2h4.498a1 1 0 0 0 .354-.063 1 1 0 0 0 .64-.811q.008-.07.008-.137V4.847a1 1 0 0 0-2 0v2.09l-1.48-1.475h-.001a9.25 9.25 0 1 0 0 13.076 1 1 0 1 0-1.414-1.414A7.25 7.25 0 1 1 9.222 5.301"
  })));
};
export default SvgIconDirections10;